<template>
  <v-row class="form-input">
    <v-col v-if="colsLabel > 0" :cols="colsLabel" class="form-input-label text-right body-2 pt-2 pb-0">
      {{ label }}
      <div v-show="optional" class="label-input-optional">(optional)</div>
    </v-col>
    <v-col :cols="cols" class="form-input-input pb-2 pt-0" :class="{readonly: $attrs.readonly != null && $attrs.readonly !== false}">
      <div v-if="!!$scopedSlots['input']" class="pt-2">
        <slot name="input"></slot>
      </div>
      <template v-else>
        <v-select dense v-bind="$attrs" v-if="isSelect" :items="items" :placeholder="$t('general.pleaseSelect')" v-model="internalValue"></v-select>
        <date-select dense v-bind="$attrs" v-else-if="isDateSelect" v-model="internalValue" :format="dateType === 'month' ? undefined : 'LL'" :type="dateType" />
        <template v-else-if="isCheckbox">
          <boolean-flag-icon v-if="isReadonly()" :value="internalValue" class="mt-2" />
          <v-checkbox v-bind="$attrs" v-else v-model="internalValue" class="mt-1"></v-checkbox>
        </template>
        <currency-input dense v-bind="$attrs" v-else-if="currency" v-model="internalValue" :currency="currency"></currency-input>
        <template v-else-if="isTextarea">
          <div class="form-input-value form-input-value-textarea" v-if="isReadonly()" v-html="internalValueHtml"></div>
          <v-textarea v-else :outlined="!isReadonly()" :no-resize="isReadonly()" :class="{'pt-0': isReadonly}" v-bind="$attrs" v-model="internalValue"></v-textarea>
        </template>
        <template v-else>
          <div class="form-input-value" v-if="isReadonly()" v-html="internalValueHtml"></div>
          <v-text-field v-else dense v-bind="$attrs" v-model="internalValue" :type="type === 'password' ? 'password' : null" :hide-details="isReadonly()"></v-text-field>
        </template>
      </template>
      <slot name="content-append"></slot>
    </v-col>
    <v-col class="form-input-help body-2 text--secondary pt-3 pb-0" v-if="!!$scopedSlots['help-text'] || helpText" :cols="colsHelp" :offset="12 - colsLabel - cols - colsHelp">
      <slot v-if="!!$scopedSlots['help-text']" name="help-text"></slot>
      <template v-else>{{ helpText }}</template>
    </v-col>
  </v-row>
</template>

<script>
import CurrencyInput from './CurrencyInput';
import DateSelect from '@/components/DateSelect';
import BooleanFlagIcon from './BooleanFlagIcon';
import {DateUtils} from '../utils/date-utils';
export default {
  name: 'FormInput',
  mixins: [
    DateUtils
  ],
  components: {BooleanFlagIcon, DateSelect, CurrencyInput},
  props: {
    value: null,
    label: null,
    colsLabel: {
      default () {
        return 2;
      }
    },
    cols: {
      default () {
        return 6;
      }
    },
    colsHelp: {
      default () {
        return 4;
      }
    },
    type: {
      type: String,
      default () {
        return 'text-field';
      }
    },
    items: null,
    currency: null,
    helpText: null,
    optional: {
      type: Boolean,
      default () {
        return false;
      }
    },
    dateType: {
      default () {
        return 'date';
      }
    }
  },
  data () {
    return {
      internalValue: null
    }
  },
  computed: {
    isSelect () {
      return this.type === 'select' || this.items;
    },
    isDateSelect () {
      return this.type === 'date';
    },
    isCheckbox () {
      return this.type === 'checkbox';
    },
    isTextarea () {
      return this.type === 'textarea';
    },
    internalValueHtml () {
      if (this.internalValue) {
        if (typeof this.internalValue === 'string') {
          return this.internalValue.replace(/\n/g, '<br>');
        } else if (typeof this.internalValue === 'number') {
          return this.internalValue;
        }
      }
      return '-';
    }
  },
  methods: {
    update (value) {
      if (this.isCheckbox) {
        value = value || false;
      }
      this.$emit('input', value);
    },
    isReadonly() {
      return typeof this.$attrs['readonly'] !== 'undefined';
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.internalValue = this.value;
        if (this.isCheckbox && this.internalValue === null) {
          this.internalValue = false;
          this.update(this.internalValue);
        }
        if (this.isDateSelect && this.value != null) {
          this.internalValue = this.getIsoDateString(this.value);
          this.update(this.internalValue);
        }
      }
    },
    internalValue () {
      this.update(this.internalValue);
    }
  }
}
</script>

<style scoped>
.readonly::v-deep div.v-input__slot::before,
.readonly::v-deep div.v-input__slot::after {
  content: none !important;
}

.label-input-optional {
  font-size: 0.8em;
}

.form-input-value {
  margin-top: 7px;
  color: rgba(0, 0, 0, 0.87);
  letter-spacing: normal;
}

.form-input-value-textarea {
  font-size: 0.85em;
}
</style>
